module.exports = __webpack_public_path__ + "media/images/icons/rooms/bed-2p-bunk-03bf9c060c7c84828fa996aa16280f83.svg";